import axios from 'axios'
import { BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarDetalhamentoFinanceiroItinerario (idItinerario, idEmpresa) {
  const url = `${URL}/itinerario/${idItinerario}/empresa/${idEmpresa}/detalhamento-financeiro`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO,
        payload: response

      })
  );
}
